<div responsive #responsive="responsive" class="relative overflow-x-hidden">
    <div class="absolute w-full left-0 bottom-0 h-8 bg-white/40 dark:bg-qo-dark-700/40"></div>
    <ul *ngIf="multiline" class="flex -mx-20 space-x-4 mb-8 opacity-40 translate-x-16">
        <ng-container *ngFor="let poster of secondaryPosters; let index = index">
            <li *ngIf="index < nbPostersToDisplay" class="flex-1">
                <picture>
                  <source srcset="assets/posters/poster{{poster.id}}.webp" type="image/webp" >
                  <source srcset="assets/posters/poster{{poster.id}}.jpg" type="image/jpg" >
                  <img class="shadow-md w-full h-full object-cover" width="300" height="424" src="assets/posters/poster{{poster.id}}.jpg" alt="" loading="lazy"/>
                </picture>
            </li>
        </ng-container>
    </ul>
    <ul class="relative flex -mx-20 space-x-4" [ngClass]="{'-mt-28': multiline}">
        <ng-container *ngFor="let poster of mainPosters; let index = index">
            <li *ngIf="index < nbPostersToDisplay" class="flex-1">
                <picture>
                  <source srcset="assets/posters/poster{{poster.id}}.webp" type="image/webp" >
                  <source srcset="assets/posters/poster{{poster.id}}.jpg" type="image/jpg" >
                  <img class="shadow-md w-full h-full object-cover" width="300" height="424" src="assets/posters/poster{{poster.id}}.jpg" alt="" loading="lazy"/>
                </picture>
            </li>
        </ng-container>
    </ul>

</div>
